import React, { useState } from 'react';
import { SEOHead } from '../components/SEOHead';

export const ContactPage: React.FC = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, message })
      });
      if (res.ok) {
        setStatus('success');
        setName(''); setEmail(''); setMessage('');
      } else {
        setStatus('error');
      }
    } catch (err) {
      setStatus('error');
    }
  };

  return (
    <div className="animate-fade-in pb-20">
      <SEOHead title="Contact - Nida Studios" description="Contact Nida Studios" />
      <div className="max-w-3xl mx-auto text-center mb-12">
        <h1 className="text-4xl font-serif font-black text-brand-900 mb-4">Contact Us</h1>
        <p className="text-gray-600">Reach out with questions, tips, or partnership inquiries. We'll respond to submissions via email.</p>
      </div>

      <div className="max-w-4xl mx-auto grid gap-6 px-4 md:grid-cols-2 items-start">
        <div className="bg-white rounded-lg p-6 shadow-sm md:col-span-1">
          <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Name</label>
            <input value={name} onChange={(e) => setName(e.target.value)} className="mt-1 block w-full border border-gray-200 rounded-md p-2" required />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 block w-full border border-gray-200 rounded-md p-2" required />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Message</label>
            <textarea value={message} onChange={(e) => setMessage(e.target.value)} rows={6} className="mt-1 block w-full border border-gray-200 rounded-md p-2" required />
          </div>
            <div className="flex items-center justify-start">
              <button type="submit" disabled={status === 'sending'} className="px-6 py-2 bg-brand-500 text-white rounded-md hover:bg-brand-600">
                {status === 'sending' ? 'Sending...' : 'Send Message'}
              </button>
            </div>
            {status === 'success' && <div className="mt-3 text-green-600">Message sent. We'll reply to your email.</div>}
            {status === 'error' && <div className="mt-3 text-red-600">Failed to send. Try again later.</div>}
          </form>
        </div>

        <div className="bg-white rounded-lg p-6 shadow-sm md:col-span-1">
          <h3 className="text-lg font-bold mb-4 font-serif">Contact Details</h3>
          <div className="text-sm text-gray-700 font-serif space-y-2">
            <div><span className="font-bold">Call:</span> +233558116041</div>
            <div><span className="font-bold">WhatsApp:</span> +233506692176</div>
            <div><span className="font-bold">Email:</span> <a href="mailto:nidatv5050@gmail.com" className="text-brand-500 hover:underline">nidatv5050@gmail.com</a></div>
            <div><span className="font-bold">Address:</span> Akweteyman, Achimota SDA Church</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
